<template>
	<div>
		<questions :question="data"/>
		<content-text
			v-if="data.answer"
			:content="data.answer"
			class="content-answer"/>
	</div>
</template>
<script>
import questions from '@/components/detail/questions';
import contentText from '@/components/detail/content';

export default {
	name: 'wrapper-answer',
	components: {
		questions,
		contentText,
	},
	props: {
		data: {
			type: Object,
			default: () => {},
		},
	},
};
</script>
<style lang="scss" scoped>
	.content-answer {
		margin-left: auto;
		width: calc(100% - 14.1rem);
	}

	@media screen and (max-width: 1024px) {
		.content-answer {
			width: 100%;
		}
	}
</style>







// WEBPACK FOOTER //
// wrapperAnswer.vue?4d9fb7c0